import React from "react"
import ResponsiveSheet from "sheets/containers/ResponsiveSheet"
import * as actionCreators from "sheets/sheet-action-creators"
import { smallSheetConnection } from "sheets/selectors/sheet-selectors"
import { connect } from "react-redux"
import BACKENDERROR from "app/static/frontend/imports/backenderror"
import { helpTexts, swalContents } from "sheets/components/helpTexts"
import swal from "sweetalert"

export class SmallSheet extends React.Component {
    constructor(props) {
        super(props)
        this.load = this.load.bind(this)
    }

    load = async () => {
        try {
            this.networkRequest = this.props.loadSheet(this.props.id, this.props.sheetId)
            await this.networkRequest
        } catch (error) {
            this.props.editSheet(this.props.id, { initialSheetRequestLoading: false, loading: false })
            if (error.response.data && error.response.data.custom_error_message) {
                await swal({ ...swalContents.failLoadSheet, text: error.response.data.custom_error_message })
            } else if (error && error.response && error.response.status === 404) {
                await swal({ ...swalContents.failLoadSheet, text: "This sheet does not exist" })
            } else if (error && error.response && error.response.status === 524) {
                // This is a Cloudflare-specific Timeout status code, means the Sheet query is just too darn big
                Raven.captureMessage(
                    `Sheets Query Timed Out on sheet ${this.props.sheetId} for ${Userdata.organization_id} -  ${Userdata.organization}`,
                )
                // NOTE: runbook="https://quorumanalytics.atlassian.net/wiki/x/OgB4gg"
                const text =
                    "Your current row selection or last column selection is too large to process. Please add filters to reduce the amount of data before loading the sheet or " +
                    "reach out to us for assistance at support@quorum.us."
                await swal({ ...swalContents.failLoadSheet, text })
            } else {
                await BACKENDERROR(error, swalContents.failLoadSheet)
            }
        }
    }

    componentWillUnmount() {
        if (this.networkRequest) {
            this.networkRequest.abort()
            delete this.networkRequest
        }
    }

    render() {
        return <ResponsiveSheet load={this.load} canFitInMemory {...this.props} />
    }
}

export default connect((state, props) => smallSheetConnection(state, props), actionCreators)(SmallSheet)
